import { useEffect } from 'react';

/** Product name shown at the end of every browser tab title. */
export const DOCUMENT_TITLE_APP_NAME = 'KollabHR';

/** Joins a page name and the product name the way every portal titles a tab. */
export const formatDocumentTitle = (
  title?: string | null,
  appName: string = DOCUMENT_TITLE_APP_NAME
) => (title ? `${title} | ${appName}` : appName);

/**
 * Sets the browser tab title to `"<title> | KollabHR"`, or just the product
 * name while `title` is empty (a page still loading its record, a route with
 * no name). Pass an already translated string: the title follows a language
 * switch because the caller re-renders with the new string.
 */
export function useDocumentTitle(
  title?: string | null,
  appName: string = DOCUMENT_TITLE_APP_NAME
) {
  useEffect(() => {
    document.title = formatDocumentTitle(title, appName);
  }, [title, appName]);
}
